export default __webpack_public_path__ + "static/media/bio-profile-image.0a8b19bc.jpg";